import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedComponent } from './shared.component';
import { MenuComponent } from './menu/menu.component';
import { IonicModule } from '@ionic/angular';
import { FilterComponent } from './filter/filter.component';
import { WhyPurchaseAddonComponent } from './why-purchase-addon/why-purchase-addon.component';
import { FaqComponent } from './faq/faq.component';
import { AddonCardComponent } from './addon-card/addon-card.component';
import { SubscribeComponent } from './subscribe/subscribe.component';
import { VerificationComponent } from './verification/verification.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ExpandableComponent } from './expandable/expandable.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SuccessComponent } from './success/success.component';
import { GeneralNotificationComponent } from './general-notification/general-notification.component';
import { AccountListComponent } from './account-list/account-list.component';
import { VerificationLoginComponent } from './verification-login/verification-login.component';
import { ElifeDetailComponent } from './elife-detail/elife-detail.component';
import { ViewCmsContentComponent } from './view-cms-content/view-cms-content.component';
import { ElifeSubscribeComponent } from './elife-subscribe/elife-subscribe.component';
import { CountryListComponent } from './country-list/country-list.component';
import { CfmViewFormComponent } from './cfm-view-form/cfm-view-form.component';
import { SortComponent } from './sort/sort.component';
import { ValidityFormatComponent } from './validity-format/validity-format.component';
import { CfmModelComponent } from './cfm-view-form/cfm-model/cfm-model.component';
import { ListFilterPipe } from '../pipes/list-filter.pipe';
import { ErrorComponent } from './error/error.component';
import { environment } from 'src/environments/environment';
import { NgSelectModule } from '@ng-select/ng-select';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { NgbDatepickerModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { AddToBillSubscribeComponent } from './add-to-bill-subscribe/add-to-bill-subscribe.component';
import { UploadDocComponent } from './upload-doc/upload-doc.component';
import { DocumentUploadModalComponent } from './document-upload-modal/document-upload-modal.component';
import { DraggableAttachmentComponent } from './draggable-attachment/draggable-attachment.component';
import { OcrErrorModalComponent } from './ocr-error-modal/ocr-error-modal.component';
import { AlaphabeticCountryListComponent } from './alaphabetic-country-list/alaphabetic-country-list.component';
import { LearnMoreTravelInsuranceComponent } from './learn-more-travel-insurance/learn-more-travel-insurance.component';
import { LimitClassPipe } from '../pipes/limit-class.pipe';
import { ProRataPricesModalComponent } from './pro-rata-prices-modal/pro-rata-prices-modal.component';
import { AutopayCmsComponent } from './autopay-cms/autopay-cms.component';
import { LayoutsModule } from '../layouts/layouts.module';
import { CmsContentLoadComponent } from './cms-content-load/cms-content-load.component';
import { RoamingSearchCountryModalComponent } from './roaming-search-country-modal/roaming-search-country-modal.component';
import { RoamingSearchOptionsComponent } from './roaming-search-options/roaming-search-options.component';
import { GuestSegmentsComponent } from './guest-segments/guest-segments.component';
import { ArenaProComponent } from './arena-pro/arena-pro.component';
import { ItemCardComponent } from './item-card/item-card.component';
import { InventoryListComponent } from './inventory-list/inventory-list.component';
import { AddonCardUpliftComponent } from './addon-card-uplift/addon-card-uplift.component';
import { CfmAddonDetailComponent } from './cfm-addon-detail/cfm-addon-detail.component';
import { GenericContentNodeComponent } from './generic-content-node/generic-content-node.component';
import { SwiperModule } from 'swiper/angular';
import { BogoOfferPopupComponent } from './bogo-offer-popup/bogo-offer-popup.component';
import { ContentPassCardComponent } from './content-pass-card/content-pass-card.component';
import { ChangePackConfirmationModalComponent } from './change-pack-confirmation-modal/change-pack-confirmation-modal.component';
import { NoteWithIconComponent } from './note-with-icon/note-with-icon.component';
import { SubscriptionSuccessfulComponent } from './subscription-successful/subscription-successful.component';
import { PaidPassModalComponent } from './paid-pass-modal/paid-pass-modal.component';


import { ArenaProGamingErrorComponent } from './arena-pro-gaming-error/arena-pro-gaming-error.component';
import { ArenaProSuccessComponent } from './arena-pro-success/arena-pro-success.component';
import { DeviceCardComponent } from './device-card/device-card.component';
import { NavigationBarComponent } from './navigation-bar/navigation-bar.component';
import { TermsAndConditionModalComponent } from './terms-and-condition-modal/terms-and-condition-modal.component';
import { CountryFilterPipe } from '../pipes/country-filter.pipe';
import { AddonGridComponent } from './addon-grid/addon-grid.component';
import { PostpaidLinePlanPassesComponentComponent } from './postpaid-line-plan-passes-component/postpaid-line-plan-passes-component.component';
import { CfmFaqComponent } from './cfm-faq/cfm-faq.component';
import { ContentPassPromotionBannerComponent } from './content-pass-promotion-banner/content-pass-promotion-banner.component';

import { AccountSelectionModalComponent } from './account-selection-modal/account-selection-modal.component';
import { OtpVerificationComponent } from './otp-verification/otp-verification.component';
@NgModule({
  imports: [
    NgbTooltipModule,
    CommonModule,
    IonicModule,
    NgOtpInputModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgbDatepickerModule,
    LayoutsModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    SwiperModule
  ],
  declarations: [
    SharedComponent,
    MenuComponent,
    FilterComponent,
    WhyPurchaseAddonComponent,
    FaqComponent,
    AddonCardComponent,
    AddonGridComponent,
    SubscribeComponent,
    VerificationComponent,
    ExpandableComponent,
    SuccessComponent,
    GeneralNotificationComponent,
    AccountListComponent,
    VerificationLoginComponent,
    ElifeDetailComponent,
    ViewCmsContentComponent,
    ElifeSubscribeComponent,
    CountryListComponent,
    CfmViewFormComponent,
    SortComponent,
    ValidityFormatComponent,
    CfmModelComponent,
    ListFilterPipe,
    ErrorComponent,
    NavBarComponent,
    AddToBillSubscribeComponent,
    UploadDocComponent,
    DocumentUploadModalComponent, 
    DraggableAttachmentComponent,
    OcrErrorModalComponent,
    AlaphabeticCountryListComponent,
    LearnMoreTravelInsuranceComponent,
    LimitClassPipe,
    ProRataPricesModalComponent,
    AutopayCmsComponent,
    CmsContentLoadComponent,
    RoamingSearchCountryModalComponent,
    RoamingSearchOptionsComponent,
    GuestSegmentsComponent,
    ArenaProComponent,
    ItemCardComponent,
    InventoryListComponent,
    ArenaProGamingErrorComponent,
    ArenaProSuccessComponent,
    DeviceCardComponent,
    NavigationBarComponent,
    TermsAndConditionModalComponent,
    CountryFilterPipe,
    AddonGridComponent,
    AddonCardUpliftComponent,
    CfmAddonDetailComponent,
    GenericContentNodeComponent,
    BogoOfferPopupComponent,
    ContentPassCardComponent,
    ChangePackConfirmationModalComponent,
    NoteWithIconComponent,
    SubscriptionSuccessfulComponent,
    PaidPassModalComponent,
    PostpaidLinePlanPassesComponentComponent,
    CfmFaqComponent,
    ContentPassPromotionBannerComponent,
    AccountSelectionModalComponent,
    OtpVerificationComponent,
  ],
  entryComponents: [
    MenuComponent,
    FilterComponent,
    WhyPurchaseAddonComponent,
    FaqComponent,
    AddonCardComponent,
    AddonGridComponent,
    SubscribeComponent,
    VerificationComponent,
    ExpandableComponent,
    SuccessComponent,
    GeneralNotificationComponent,
    AccountListComponent,
    VerificationLoginComponent,
    ElifeDetailComponent,
    ViewCmsContentComponent,
    ElifeSubscribeComponent,
    CountryListComponent,
    AlaphabeticCountryListComponent,
    CfmViewFormComponent,
    SortComponent,
    ValidityFormatComponent,
    CfmModelComponent,
    ErrorComponent,
    NavBarComponent,
    AddToBillSubscribeComponent,
    UploadDocComponent,
    DocumentUploadModalComponent, 
    DraggableAttachmentComponent,
    OcrErrorModalComponent,
    ProRataPricesModalComponent,
    AutopayCmsComponent,
    CmsContentLoadComponent,
    RoamingSearchOptionsComponent,
    ArenaProComponent,
    ItemCardComponent,
    InventoryListComponent,
    ArenaProGamingErrorComponent,
    ArenaProSuccessComponent,
    NavigationBarComponent,
    AddonGridComponent,
    AddonCardUpliftComponent,
    GenericContentNodeComponent,
    ContentPassCardComponent,
    PostpaidLinePlanPassesComponentComponent,
    CfmFaqComponent,
    ContentPassPromotionBannerComponent
  ],
  exports: [
    MenuComponent,
    FilterComponent,
    WhyPurchaseAddonComponent,
    FaqComponent,
    AddonCardComponent,
    AddonGridComponent,
    SubscribeComponent,
    VerificationComponent,
    ExpandableComponent,
    SuccessComponent,
    GeneralNotificationComponent,
    AccountListComponent,
    VerificationLoginComponent,
    ElifeDetailComponent,
    ViewCmsContentComponent,
    ElifeSubscribeComponent,
    CountryListComponent,
    AlaphabeticCountryListComponent,
    CfmViewFormComponent,
    SortComponent,
    ValidityFormatComponent,
    CfmModelComponent,
    ErrorComponent,
    NavBarComponent,
    AddToBillSubscribeComponent,
    UploadDocComponent,
    DocumentUploadModalComponent, 
    DraggableAttachmentComponent,
    OcrErrorModalComponent,
    ProRataPricesModalComponent,
    AutopayCmsComponent,
    CmsContentLoadComponent,
    RoamingSearchOptionsComponent,
    ArenaProComponent,
    ItemCardComponent,
    InventoryListComponent,
    ArenaProGamingErrorComponent,
    ArenaProSuccessComponent,
    AddonGridComponent,
    AddonCardUpliftComponent,
    GenericContentNodeComponent,
    ContentPassCardComponent,
    PaidPassModalComponent,
    PostpaidLinePlanPassesComponentComponent,
    CfmFaqComponent,
    ContentPassPromotionBannerComponent,
    NavigationBarComponent
  ],
})
export class SharedModule { }
// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, environment.TRANSLATION_URL, '.json');
}
